import React, { FC } from "react";

import { BaseComponentProps } from "@keepeek/commons";
import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { KHeaderWidget } from "../../../../models/configuration/components/kHeaderWidget";
import EditableSanitizeHtml from "../../../FrontEdit/EditableSanitizeHtml";
import { useKHeaderWidgetSelect } from "../hooks/useKHeaderWidgetSelect";
import { classes } from "../styles";
import KheaderWidgetLinkLogo from "./KHeaderWidgetLinkLogo";

type KHeaderWidgetLogoBox = {
  widgetId: KHeaderWidget["id"];
} & BaseComponentProps;

const KHeaderWidgetLogoBox: FC<React.PropsWithChildren<KHeaderWidgetLogoBox>> = function ({
  widgetId,
  className,
  ...rest
}) {
  const configuration = useKHeaderWidgetSelect({ widgetId });
  const { i18n } = useTranslation();

  return (
    <Box className={className} {...rest}>
      <KheaderWidgetLinkLogo kHeaderWidgetLogo={configuration?.kHeaderWidgetLogo} />
      {/* custom label key to set a title if it's present in Admin ReFront labels section */}
      {i18n.exists("layout.app-bar.title.label") && (
        <Typography variant="h2" className={clsx(classes.title, "header-title")}>
          <EditableSanitizeHtml labelKey={"layout.app-bar.title.label"} />
        </Typography>
      )}
    </Box>
  );
};

export default KHeaderWidgetLogoBox;
